export default Object.freeze({
  june: 6,
  may: 5,
  december: 12,
});
